import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const features = [{
  feature: 'Contenido 100% argentino',
  detail: 'CPPN, Vucetich, BNDG, EAAF, PFA, CONARC, RENAPER, INTERPOL, Ley 26.388'
}, {
  feature: 'Material imprimible',
  detail: 'Listo para usar en el aula o entregar directamente al alumno'
}, {
  feature: 'Checklists y formularios reales',
  detail: 'Protocolos argentinos 2026 adaptados para uso pedagógico'
}, {
  feature: 'Casos resueltos paso a paso',
  detail: 'Con datos reales de la práctica criminalística argentina'
}, {
  feature: 'Vocabulario técnico explicado',
  detail: 'Sin tecnicismos innecesarios para el nivel del aula'
}, {
  feature: 'Conexión con la actualidad',
  detail: 'Protocolo 485/2024, escaneo 3D, drones forenses, ciberdelitos, IA forense'
}, {
  feature: 'Historia y contexto argentino',
  detail: 'Desde el caso Rojas 1892 hasta los protocolos digitales de 2026'
}, {
  feature: '4 Bonos estratégicos',
  detail: 'Evaluaciones, casos, kit profesional y recursos visuales'
}, {
  feature: 'Garantía de 7 días',
  detail: 'Sin preguntas ni formularios'
}, {
  feature: 'Acceso inmediato',
  detail: 'Descarga directa tras la compra'
}, {
  feature: 'Actualizaciones gratuitas',
  detail: 'Acceso de por vida al material'
}];
export function IncludesChecklist() {
  return <section className="py-12 bg-navy-950 border-y border-silver/20" data-id="element-143" data-mp="1sau1igk57ke3">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-144" data-mp="1sconzzb2bkka">
        <h2 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-145" data-mp="262ibad6x5wrw">
          ✅ TODOS LOS TOMOS INCLUYEN
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-146" data-mp="21aql43rodt2a">
          {features.map((item, i) => <motion.div key={item.feature} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg bg-navy-900/40 border border-silver/10" data-id="element-147" data-mp="1dk4or9r19x84" data-mpi={i}>
              <CheckCircle2Icon className="w-5 h-5 text-silver shrink-0 mt-0.5" data-id="element-148" data-mp="2pqrnavekkjq8" />
              <div data-id="element-149" data-mp="2upb9mwx2rxj4">
                <p className="text-silver-light font-bold text-[16px]" data-id="element-150" data-mp="2uojgrtuv4dwj">
                  {item.feature}
                </p>
                <p className="text-silver text-sm" data-id="element-151" data-mp="2znmoxn65308q">{item.detail}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}